<template>
  <div class="header-section">
    <h2
      class="index-title center bold"
      :class="[params.sub_title ? '' : 'index-title-margin-bottom']"
      v-html="params.title"
    ></h2>
    <p
      v-if="params.sub_title || params.subTitle"
      class="index-subtitle center"
    >
      {{ params.sub_title || params.subTitle }}
    </p>
    <span
      v-if="showBack"
      class="back"
      @click="backHandle"
    ></span>
    <img
      v-if="showError"
      class="half-drawer-close"
      src="../../assets/close.png"
      @click="cancelHandler"
    />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'HeadlineItem',

  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    showError: {
      type: Boolean,
      default: true,
    },
    showBack: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    cancelHandler() {
      this.$emit('onCancel');
    },
    backHandle() {
      this.$emit('backHandle');
    },
  },
});
</script>

<style lang="less" scoped>
@import '../../styles/variable.less';
@import '../../styles/public-class.less';
// 半页title 区域
.header-section {
  padding-top: 0.64rem;

  .index-title {
    line-height: 0.64rem;
    font-size: 0.48rem;
    color: @mainText;
    padding-bottom: 0.1rem;
  }
  .index-subtitle {
    line-height: 1;
    font-size: 0.24rem;
    color: @regularText;
    padding-bottom: 0.6rem;
  }
  .index-title-margin-bottom {
    padding-bottom: 0.6rem;
  }
}
</style>
